import * as React from 'react'
import styled from 'styled-components'
import { colors } from '@components/shared/colors'
import { config } from 'react-awesome-styled-grid'
import FlameFilledIcon from '@components/shared/icons/FlameFilledIcon'

type PropsType = {
  text: string
}

export function SexIndicatorBadge (props: PropsType): React.ReactNode {
  return (
    <SexIndicatorBadgeContainer>
      <MinutesOfSexBubble>
        <Pointer />
        <FlameFilledIcon />
        <MinutesofSexText>{props.text}</MinutesofSexText>
      </MinutesOfSexBubble>
    </SexIndicatorBadgeContainer>
  )
}

const MinutesOfSexBubble = styled.div<any>`
    flex: 0 1 auto;
    align-items: center;
    justify-content: center;
    position: relative;
    background-color: ${colors.white};
    border-radius: 4px;
    flex-direction: row;
    display: flex;
    padding: 4px;
`

const MinutesofSexText = styled.div<any>`
    background-color: ${colors.white};
    color: ${colors.midnightBlue};
    margin-left: 4px;
    font-family: "Good Sans Regular";
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 114%; /* 114.286% */
`
const Pointer = (): React.ReactNode => {
  return (
    <PointerContainer>
      <svg width='13' height='16'>
        <path
          d='M0.499999 8.86602C-0.166667 8.48112 -0.166666 7.51887 0.500001 7.13397L11 1.0718C11.6667 0.686898 12.5 1.16802 12.5 1.93782L12.5 14.0622C12.5 14.832 11.6667 15.3131 11 14.9282L0.499999 8.86602Z'
          fill={colors.white}
        />
      </svg>
    </PointerContainer>
  )
}

const PointerContainer = styled.div<any>`
    justify-content: center;
    left: -8px;
    overflow: hidden;
    position: absolute;
    top: 4px;
`

const SexIndicatorBadgeContainer = styled.div<any>`
    display: flex;
    ${(props: any): any => config(props).media.xs`
  `}
    ${(props: any): any => config(props).media.sm`
  `}
    ${(props: any): any => config(props).media.md`
  `}
    ${(props: any): any => config(props).media.lg`
  `}
    ${(props: any): any => config(props).media.xl`
  `}
`
